var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('div',{staticClass:"desktop-sidebar-items"},[_c('sidebar-item',{attrs:{"link":{
          name: 'داشبورد',
          path: '/dashboard',
          icon: 'fas fa-shopping-bag'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'کاربران',

          icon: 'fas fa-users'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'همه کاربران',
            path: '/users/all',
            icon: 'fas fa-shopping-bag'
          }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'مدارک در انتظار تایید ',
              path: '/users/document',
              icon: 'fas fa-shopping-bag',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'اطلاعات اولیه در انتظار تایید',
              path: '/users/personal-info',
              icon: 'fas fa-shopping-bag',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'آدرس های در انتظار تایید',
              path: '/users/addresses',
              icon: 'fas fa-shopping-bag',
            }}}),(_vm.checkAccessIbanPending)?_c('sidebar-item',{attrs:{"link":{
              name: 'شبا های تائید نشده',
              path: '/iban',
            }}}):_vm._e(),(_vm.checkAccessIbanPending)?_c('sidebar-item',{attrs:{"link":{
              name: 'کارت های تائید نشده',
              path: '/cards',
            }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: 'پشتیبانی',
          icon: 'fas fa-envelope-open-text'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'همه تیکت ها',
            path: '/support',
            icon: 'fas fa-shopping-bag'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'دپارتمان ها',
            path: '/support-departments',
            icon: 'fas fa-shopping-bag'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'گزارشات',
            icon: 'fas fa-list',
          }}},[(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'موجودی سیستم',
              path: '/reports/user-balances',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'برداشت های ناموفق تومانی',
              path: '/reports/open-withdrawals',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'برداشت های ناموفق پرفکت مانی',
              path: '/reports/prefect-money-open-withdrawals',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'تراکنش های درگاه',
              path: '/reports/fiat-transaction',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'واریز و برداشت های کریپتو',
              path: '/reports/transactions',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'تریدها',
              path: '/reports/orders',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'جوایز',
              path: '/reports/reward',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'پرفکت مانی',
              path: '/reports/perfect-money',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'گردگیری',
              path: '/reports/dusting',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'خریدوفروش',
              path: '/reports/totals',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'واریز های بانکی',
              path: '/reports/manual-fiat-deposit',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'تراکنش های دستی',
              path: '/reports/manual-balance-change',
            }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
            path:'/reward-center',
            name: 'سرویس جایزه ها',
            icon: 'fa fa-gift'
          }}},[_c('sidebar-item',{staticClass:"mb-0",attrs:{"link":{
            name: 'جایزه ها',
            path:'/reward-center/rewards',
          }}},[_c('sidebar-item',{staticClass:"mb-0",attrs:{"link":{
                name: 'ایجاد',
                path:'/reward-center/rewards/create',
              }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'لیست ',
              path:'/reward-center/rewards/list',
             }}}),_c('sidebar-item',{attrs:{"link":{
               name: 'لیست شروط',
               path:'/reward-center/rewards/conditions',
             }}})],1),_c('sidebar-item',{staticClass:"mb-0",attrs:{"link":{
            name: 'جوایز دریافت شده',
            path:'/reward-center/achieved-rewards',
          }}},[_c('sidebar-item',{staticClass:"mb-0",attrs:{"link":{
                name: 'محاسبه شده ها',
                path:'/reward-center/achieved-rewards/calculated',
              }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'تایید شده ها',
              path:'/reward-center/achieved-rewards/confirmed',
             }}}),_c('sidebar-item',{attrs:{"link":{
               name: 'پرداخت شده ها',
             path:'/reward-center/achieved-rewards/paid',
             }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'خزانه',
          path: '/treasury',
          icon: 'fa fa-credit-card'
        }}}),_c('sidebar-item',{attrs:{"link":{
               name: 'اختصاص جایزه',
             path:'/reward-center/add-reward-to-user',
             }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'تنظیمات',
            icon: 'fas fa-cog'
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'مدیریت ارز ها',
                path: '/setting/assets',
                icon: 'fas fa-gear'
             }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'تنظیمات قیمت',
            path: '/setting/prices',
            icon: 'fas fa-shopping-bag'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'پشتیبان ها',
            path: '/interview/agents',
            icon: 'fas fa-gear'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'تنظیمات قرار',
            path: '/interview/setting',
            icon: 'fas fa-shopping-bag'
          }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'تنظیمات ووچر',
              path: '/setting/voucher',
              icon: 'fas fa-shopping-bag',
            }}}),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'تنظیمات عملیات',
              path: '/setting/operations',
              icon: 'fas fa-shopping-bag',
            }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: 'تنظیمات اطلاعیه',
              path: '/setting/announcement',
              icon: 'fas fa-shopping-bag',
            }}}):_vm._e()],1)],1)])],2),_c('curtain-menu',{attrs:{"user":_vm.user,"show":true}}),_c('div',{staticClass:"notification-sidebar"},[_c('b-sidebar',{attrs:{"no-header":"","header-class":"notification-sidebar-header","id":"sidebar-backdrop","title":"اعلان ها","backdrop-variant":"dark","bg-variant":"white","backdrop":"","shadow":"","width":"460"}},[_c('div',{staticClass:"notification-sidebar-header"},[_c('div',{staticClass:"col-1",staticStyle:{"padding":"0"}},[_c('b-icon',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-backdrop",modifiers:{"sidebar-backdrop":true}}],staticClass:"close-icon",attrs:{"icon":"x","scale":"2"}})],1),_c('div',{staticClass:"col-6",staticStyle:{"padding":"0"}},[_c('h3',{staticClass:"notification-sidebar-header-title"},[_vm._v("اعلان ها")])]),_c('div',{staticClass:"col-lg-5 col-0 select-box",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"notification-sidebar-header-select-container"},[_c('b-form-select',{staticClass:"notification-sidebar-header-select",attrs:{"options":_vm.options,"plain":""},on:{"change":function($event){return _vm.changeFilter()}},model:{value:(_vm.selectedFilter),callback:function ($$v) {_vm.selectedFilter=$$v},expression:"selectedFilter"}})],1)]),_c('div',{staticClass:"col-5 col-lg-0 dropdown-box",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"notification-sidebar-header-select-container"},[_c('div',[_c('b-form-select',{staticClass:"notification-sidebar-header-select",attrs:{"options":_vm.options,"plain":""},on:{"change":function($event){return _vm.changeFilter()}},model:{value:(_vm.selectedFilter),callback:function ($$v) {_vm.selectedFilter=$$v},expression:"selectedFilter"}})],1)])])]),_c('div',{staticClass:"notification-sidebar-body"},[(_vm.loading)?_c('b-skeleton-table',{attrs:{"rows":15,"columns":2,"table-props":{ bordered: true, striped: true }}}):_vm._e(),(_vm.selectedFilter == null && !_vm.loading)?_c('b-list-group',{staticClass:"notification-items-container"},_vm._l((_vm.messages),function(message,index){return _c('b-list-group-item',{key:index,staticClass:"flex-column align-items-start notification-items"},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.getNotificationMessage(message).title)+" "),_c('b-icon',{staticClass:"icon-button",attrs:{"font-scale":"0.9","icon":message.seen == false ? 'eye' : 'eye-fill'},on:{"click":function($event){return _vm.setSeen(message.id)}}})],1),_c('small',{staticClass:"date"},[_c('b-icon',{staticClass:"icon-button",attrs:{"font-scale":"0.9","icon":"x-circle-fill"},on:{"click":function($event){return _vm.deletMessage(message.id)}}})],1)]),_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.getNotificationMessage(message).message)+" ")]),(_vm.getNotificationMessage(message).path)?_c('b-link',{staticClass:"link",attrs:{"to":_vm.getNotificationMessage(message).path}},[_vm._v(_vm._s(_vm.getNotificationMessage(message).pathname)+" "),_c('b-icon',{staticClass:"bi-chevron-left",attrs:{"icon":"chevron-left"}})],1):_vm._e()],1)}),1):_vm._e(),(_vm.selectedFilter != null)?_c('b-list-group',{staticClass:"notification-items-container"},_vm._l((_vm.filteredMessages),function(message,index){return _c('b-list-group-item',{key:index,staticClass:"flex-column align-items-start notification-items"},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.getNotificationMessage(message).title)+" "),_c('b-icon',{staticClass:"icon-button",attrs:{"font-scale":"0.9","icon":message.seen == false ? 'eye' : 'eye-fill'},on:{"click":function($event){return _vm.setSeen(message.id)}}})],1),_c('small',{staticClass:"date"},[_c('b-icon',{staticClass:"icon-button",attrs:{"font-scale":"0.9","icon":"x-circle-fill"},on:{"click":function($event){return _vm.deletMessage(message.id)}}})],1)]),_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.getNotificationMessage(message).message)+" ")]),(_vm.getNotificationMessage(message).path)?_c('b-link',{staticClass:"link",attrs:{"to":_vm.getNotificationMessage(message).path}},[_vm._v(_vm._s(_vm.getNotificationMessage(message).pathname)+" "),_c('b-icon',{staticClass:"bi-chevron-left",attrs:{"icon":"chevron-left"}})],1):_vm._e()],1)}),1):_vm._e()],1)])],1),_c('div',{staticClass:"main-content main-content-without-tabs"},[_c('dashboard-navbar',{attrs:{"user":_vm.user,"type":_vm.$route.meta.navbarType}}),_c('div',[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }